var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgDisplayExtraSmallCustomX = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h20v20H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.742 3.258a1.072 1.072 0 0 0-1.516 0L10 8.484 4.774 3.258a1.072 1.072 0 1 0-1.516 1.516L8.484 10l-5.226 5.226a1.072 1.072 0 1 0 1.516 1.516L10 11.516l5.226 5.226a1.072 1.072 0 1 0 1.516-1.516L11.516 10l5.226-5.226a1.072 1.072 0 0 0 0-1.516z",
    fill: "#9A5238",
    fillRule: "nonzero"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgDisplayExtraSmallCustomX);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/display-extra-small-custom-x.907f76fcab30b3f9a39ee681d4e18269.svg";